var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33334C10.4602 3.33334 10.8333 3.70644 10.8333 4.16668V9.16668H15.8333C16.2936 9.16668 16.6667 9.53978 16.6667 10C16.6667 10.4603 16.2936 10.8333 15.8333 10.8333H10.8333V15.8333C10.8333 16.2936 10.4602 16.6667 10 16.6667C9.53977 16.6667 9.16668 16.2936 9.16668 15.8333V10.8333H4.16668C3.70644 10.8333 3.33334 10.4603 3.33334 10C3.33334 9.53978 3.70644 9.16668 4.16668 9.16668H9.16668V4.16668C9.16668 3.70644 9.53977 3.33334 10 3.33334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.17b4323fad3382e8fe76a84aedb645e4.svg";
export { ForwardRef as ReactComponent };